import React from 'react';
import { createRoot } from 'react-dom/client';

import 'highlight.js/styles/shades-of-purple.css';
import './style.css';

import App from './App';

const VIZ_POLL_INTERVAL_MS = 200;
const RENDER_EVENT = new CustomEvent('render');

function renderVisibleFractalCanvases() {
  const viewportHeight = window.innerHeight;
  const canvases = document.getElementsByTagName('canvas');
  [...canvases].forEach((canvas) => {
    const rect = canvas.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > viewportHeight) {
      // canvas is not visible
    } else {
      // canvas is visible
      canvas.dispatchEvent(RENDER_EVENT);
    }
  });
}

function renderVisibleFractalCanvasesForever() {
  renderVisibleFractalCanvases();
  setTimeout(() => {
    renderVisibleFractalCanvasesForever();
  }, VIZ_POLL_INTERVAL_MS);
}

// entry point (React 18+ createRoot API)
const container = document.getElementById('react-mount');
createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
renderVisibleFractalCanvasesForever();
